export const messageItemStyle = {
    display: "inline-flex",
    alignItems: "center",
};

export const getSeparatorStyle = (isSaleSeason: boolean) => ({
    mx: 4,
    color: isSaleSeason ? "white" : "black",
    fontWeight: "bold",
});
